import { render, staticRenderFns } from "./DownloadInvoiceTooltip.vue?vue&type=template&id=5f833f48&scoped=true&"
import script from "./DownloadInvoiceTooltip.vue?vue&type=script&lang=js&"
export * from "./DownloadInvoiceTooltip.vue?vue&type=script&lang=js&"
import style0 from "./DownloadInvoiceTooltip.vue?vue&type=style&index=0&id=5f833f48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f833f48",
  null
  
)

export default component.exports